import * as _ from 'lodash';
import * as utility from '../misc/utility';
import { Person } from '../objects/Person';

angular.module("tromanWeb").factory('ObjectCache', ['$q', 'tromanServer', 'accountServer', 'isTroman', function ($q, tromanServer, accountServer, isTroman) {

    var so = {};

    function compareBy(prop) {
        return function compareByProp(a, b) {
            if (a == null && b == null) return 0;
            if (a == null) return 1;
            if (b == null) return -1;

            return utility.compare(a[prop], b[prop]) || utility.compare(a.Id, b.Id);
        };
    }

    const compareByName = compareBy("Name");
    const compareByCode = compareBy("Code");

    function includeResult(data, include) {
        var ii, item;

        function isItem(x) {
            return x.Id === item.Id;
        }

        if (include != null) {

            if (!angular.isArray(include)) {
                include = [include];
            }

            for (ii = 0; ii < include.length; ++ii) {
                item = include[ii];
                if (item.Id != null) {
                    var exists = data.some(isItem);
                    if (!exists) {
                        data.push(item);
                    }
                }
            }
        }
    }

    so.getOrganizations = function (include, criteria) {
        return tromanServer.Organizations.search(criteria || {}).then(function (data) {
            includeResult(data, include);
            data.sort(compareByName);
            return data;
        });
    };

    so.allOrganizations = function () {
        return this.getOrganizations(null, { Archived: true });
    };

    so.getParties = function (include, criteria) {
        return tromanServer.Parties.search(criteria || {}).then(function (data) {
            includeResult(data, include);
            data.sort(compareByName);
            return data;
        });
    };

    so.allParties = function () {
        return this.getParties(null, { Archived: true });
    };

    so.getDivisions = function (include, criteria) {
        return tromanServer.Divisions.search(criteria || {}).then(function (data) {
            includeResult(data, include);
            data.sort(compareByName);
            return data;
        });
    };

    so.getMissionTypes = function (include, criteria) {
        return tromanServer.MissionTypes.search(criteria || {}).then(function (data) {
            includeResult(data, include);
            data.sort(compareByName);
            return data;
        });
    };

    so.getOrganizationTypes = function (include, criteria) {
        return tromanServer.OrganizationTypes.search(criteria || {}).then(function (data) {
            includeResult(data, include);
            data.sort(compareByName);
            return data;
        });
    };

    so.getPersons = function (include, criteria) {
        return tromanServer.Persons.search(criteria || {}).then(function (data) {
            includeResult(data, include);
            data.sort(Person.compare);
            return data;
        });
    };

    so.getWageCalculations = function (include, criteria) {
        return tromanServer.WageCalculations.search(criteria || {}).then(function (data) {
            includeResult(data, include);
            data.sort(compareByName);
            return data;
        });
    };

    so.getWageGroups = function (include, criteria) {
        return tromanServer.WageGroups.search(criteria || {}).then(function (data) {
            includeResult(data, include);
            data.sort(compareByName);
            return data;
        });
    };

    so.getWageTypes = function (include, criteria) {
        return tromanServer.WageTypes.search(criteria || {}).then(function (data) {
            includeResult(data, include);
            data.sort(compareByCode);
            return data;
        });
    };

    so.allWageTypes = function () {
        return this.getWageTypes(null, { Archived: true });
    };

    so.getAllUsers = function () {
        return accountServer.Users.getUsers();
    };

    so.getUsers = function (additionalIds) {
        return accountServer.Users.getUsers().then(function (data) {
            var users = _.filter(data, x => (isTroman ? x.HasTroman : x.HasValman) || _.includes(additionalIds, x.Id));
            return _.sortBy(users, ['UserName']);
        });
    };

    so.getSettings = function (criteria) {
        return $q.all({
            settings: tromanServer.Settings.search(criteria),
            users: accountServer.Users.getUsers(),
        }).then(function (data) {
            return _.transform(data.settings, (result, setting) => {
                if (setting.SharedByUserId == null) {
                    result.push(setting);
                } else {
                    let user = _.find(data.users, x => x.Id === setting.SharedByUserId && (isTroman ? x.HasTroman : x.HasValman));
                    if (user != null) {
                        setting.title += " (" + user.UserName + ")";
                        result.push(setting);
                    }
                }
            });
        });
    };

    return so;

}]);